import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
  id: string,
}

const initialState = {};

export default function reduceAdminTalentScorecard(state = initialState, action: AdminActions) {
  if (!action.type || !action?.id) {
    return state;
  }

  switch (action.type) {
  case ActionTypes.admin.getTalentScorecard.START:
    return {
      ...state,
      [action.id]: {
        ...state[action?.id],
        fetching: true,
      },
    };

  case ActionTypes.admin.getTalentScorecard.SUCCESS:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        fetching: false,
      },
    };

  case ActionTypes.admin.getTalentScorecard.ERROR:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        fetching: false,
      },
    };

  case ActionTypes.admin.patchTalentScorecard.START:
    return {
      ...state,
      [action.id]: {
        ...state[action?.id],
        isPatching: true,
      },
    };

  case ActionTypes.admin.patchTalentScorecard.SUCCESS:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        isPatching: false,
      },
    };

  case ActionTypes.admin.patchTalentScorecard.ERROR:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        isPatching: false,
      },
    };

  default:
    return state;
  }
}
